import Vue from 'vue'
import Vuex from 'vuex'
import userSettings from './userSettings';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    userSettings,
  }
})
